<template src="./role-management.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import { hasRoleManageClaim } from '@/router/auth.js'

export default {
  components: {
    ContextPage,
    Tabulator
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      data: [],
      totalRowsCount: '',
      RoleType: {
        SYSTEM: 1,
        ADMINONLY: 2,
        USER: 3
      },
      help: {
        list: Vue.$helpConfig.roleList
      },
      loader: false,
      loading: false,
      pageLoader: false,
      tabulatorOptions: {
        // ajaxURL: Vue.$config.api_root + '/' + Vue.$apiConfig.rolesGet,
        ajaxSorting: false,
        ajaxFiltering: false,
        pagination: undefined,
        paginationSize: undefined,
        ajaxURLGenerator: undefined,
        dataLoaded: (data) => {
          const totalElement = document.getElementsByClassName('total-rows-number')
          if (totalElement.length) {
            totalElement[0].innerHTML = this.totalRowsCount
          } else {
            totalElement[0].innerHTML = '-'
          }
        },
        columns: [
          { title: '', field: 'id', visible: false, headerSort: false },
          {
            title: this.$t('userAdministration.userRoleName'),
            field: 'name',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('userAdministration.userRoleDescription'),
            field: 'description',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('userAdministration.userRoleCreatedDate'),
            field: 'createdDate',
            headerSort: true,
            hozAlign: 'center',
            sorter: 'date',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? this.formatShortDate(cell.getValue()) : this.$t('projectStructure.notDefinedDate')
            },
            headerFilter: this.vDateRange,
            headerFilterParams: { isRange: true },
            headerFilterLiveFilter: false
          }
        ],
        rowClick: (e, row) => {
          const administrationURL = '/administration/role/' + row.getData().id
          this.handleRowClickNavigation(e, administrationURL)
        }
      }
    }
  },
  computed: {
    displayRoleCreateButton () {
      return hasRoleManageClaim()
    }
  },
  created () {
    this.getRoles()
  },
  methods: {
    getRoles () {
      this.$http.get(Vue.$config.api_root + '/' + Vue.$apiConfig.rolesGet).then(
        response => {
          this.data = response.data.payload
          this.totalRowsCount = response.data.additionalInformation
        },
        error => {
          this.logConsole(error)
        }
      )
    }
  }
}
</script>
<style>
.status-active-span {
   background-color: #4caf50;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-inactive-span {
   background-color: #ECEFF1;
   color: #000;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-revoked-span {
   background-color: #ff5252;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

</style>
